import type { Ref } from 'vue'
import { useState } from '#app'
import type { SecNotification } from '~~/types/other'

export const useNotifications = (): {
  notifications: Ref<SecNotification[]>;
  addNotification: (notification: SecNotification) => void;
  removeNotification: (uuid: number) => void
} => {
  const notifications: Ref<SecNotification[]> = useState('notifications', () => [])

  const addNotification = (notification: SecNotification): void => {
    const newNotification = {
      ...notification,
      id: notifications.value.length + 1
    }

    // add to notification queue
    notifications.value.push(newNotification)

    // set timer to remove the notification
    setTimeout(function () {
      removeNotification(newNotification.id)
    }, newNotification.duration)
  }

  const removeNotification = (notificationId: number): void => {
    notifications.value = notifications.value.filter(
      n => n.id !== notificationId
    )
  }

  return {
    notifications,
    addNotification,
    removeNotification
  }
}
